import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import "./index.css";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import HomePage from "./pages/HomePage";
import AboutPage from "./components/AboutPage";
import ContactUs from "./pages/ContactUs";
import CampaignDetailspage from "./pages/CampaignDetail";
import FundraiserForm from "./sign_in_files/FundraiserForm";
import VerifyMobileNumber from "./sign_in_files/verifyMobileNumber";
import DetailsScreen1 from "./sign_in_files/detailsScreen1"; // ✅ fixed naming
import MyContributions from "./pages/MyContributions";
import MyFundraisers from "./pages/MyFundraisers";
import AllCampaigns from "./pages/AllCampaigns";
import CrowdfundingPage from "./pages/CrowdfundingPage";
import Medical from "./pages/Medical";
import StartFundraiser from "./pages/StartFundraiser";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import LoginPage from "./pages/LoginPage";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  // ✅ Fix loading issue (IMPORTANT)
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  // Check if current path is a campaign details page
  const isCampaignPage = location.pathname.includes("/campaign/");

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-100 to-white">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-teal-600 font-semibold">Loading Donatepe...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <ScrollToTop />

      {/* Header */}
      <div className={isCampaignPage ? "hidden lg:block" : "block"}>
        <Header />
      </div>

      {/* Routes */}
      <main className="flex-grow">
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />

          {/* Static Pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/signin" element={<LoginPage />} />

          {/* Campaign */}
          <Route path="/campaign/:slugWithId" element={<CampaignDetailspage />} />
          <Route path="/campaigns" element={<AllCampaigns />} />

          {/* User */}
          <Route path="/my-contributions" element={<MyContributions />} />
          <Route path="/my-fundraiser" element={<MyFundraisers />} />

          {/* Fundraiser Flow */}
          <Route path="/start-fundraiser" element={<FundraiserForm />} />
          <Route path="/verify_mobileNumber" element={<VerifyMobileNumber />} />
          <Route path="/detailsScreen" element={<DetailsScreen1 />} />

          {/* Categories */}
          <Route path="/crowdfundraisers" element={<CrowdfundingPage />} />
          <Route path="/medical" element={<Medical />} />
          <Route path="/start-fundraiser-page" element={<StartFundraiser />} />

          {/* Legal */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

          {/* 404 */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-3xl font-bold text-gray-900 mb-4">
                    404 - Page Not Found
                  </h1>
                  <p className="text-gray-600">
                    The page you're looking for doesn't exist.
                  </p>
                </div>
              </div>
            }
          />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;